// use in lieu of striptags to convert html special characters
const convertHtmlString = (html: string, replaceLineBreaksWith?: string): string => {
  const text = document.createElement('text');
  if (replaceLineBreaksWith) {
    const container = document.createElement('div');
    container.innerHTML = html;
    const children = container.querySelectorAll('div > *');
    const childArray = Array.from(children);
    const textArray = childArray.map((child) => (child as HTMLElement).innerText);
    const text = textArray.join(replaceLineBreaksWith);
    return text;
  } else {
    text.innerHTML = html;
  }
  return text.innerText;
};

export default convertHtmlString;
